import ParentNotePreview from '@/components/ParentNotePreview'
import { eventMentionsPubKeyInContent, findFirstDirectReplyToPubkey } from '@/lib/event'
import { toNote } from '@/lib/link'
import { useSecondaryPage } from '@/PageManager'
import { useAtomValue } from 'jotai'
import { notificationListStyleAtom } from '@/atoms/preferences'
import { HugeiconsIcon } from '@hugeicons/react'
import { AtSignIcon, BubbleChatIcon, NewsIcon, QuoteUpIcon } from '@hugeicons/core-free-icons'
import { Event } from '@nostr/tools/wasm'
import { useEffect, useState } from 'react'
import { AddressPointer, EventPointer } from '@nostr/tools/nip19'
import { useTranslation } from 'react-i18next'
import Notification from './Notification'
import { useCurrentPubkey } from '@/atoms/session'

export function MentionNotification({
  notification,
  isNew = false
}: {
  notification: Event
  isNew?: boolean
}) {
  const { t } = useTranslation()
  const { push } = useSecondaryPage()
  const pubkey = useCurrentPubkey()
  const notificationListStyle = useAtomValue(notificationListStyleAtom)
  const isMention = pubkey ? eventMentionsPubKeyInContent(notification, pubkey) : false
  const [parent, setParent] = useState<EventPointer | AddressPointer | undefined>()
  useEffect(() => {
    if (pubkey) findFirstDirectReplyToPubkey(notification, pubkey).then(setParent)
  }, [notification])

  return (
    <Notification
      notificationId={notification.id}
      icon={
        isMention ? (
          <HugeiconsIcon icon={AtSignIcon} size={24} className="text-pink-400" />
        ) : parent ? (
          <HugeiconsIcon icon={BubbleChatIcon} size={24} className="text-blue-400" />
        ) : notification.pubkey === pubkey ? (
          <HugeiconsIcon icon={NewsIcon} size={24} className="text-pink-400" />
        ) : (
          <HugeiconsIcon icon={QuoteUpIcon} size={24} className="text-green-400" />
        )
      }
      sender={notification.pubkey}
      sentAt={notification.created_at}
      targetEvent={notification}
      middle={
        notificationListStyle === 'detailed' &&
        parent && (
          <ParentNotePreview
            first
            parent={parent}
            onClick={(e) => {
              e.stopPropagation()
              push(toNote(parent))
            }}
          />
        )
      }
      description={
        isMention
          ? t('mentioned you in a note')
          : parent || notification.pubkey === pubkey
            ? ''
            : t('quoted your note')
      }
      isNew={isNew}
      showStats
    />
  )
}
